import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/enterprises',
      name: 'enterprises',
      component: () => import('./views/EnterpriseList.vue')
    },
    {
      path: '/enterprises/:id',
      name: 'enterprise-detail',
      component: () => import('./views/EnterpriseDetail.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/tax-agency',
      name: 'tax-agency',
      component: () => import('./views/TaxAgency.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('./views/Services.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {
        requireAuth: true,
        requireAdmin: true
      },
      component: () => import('./views/Admin.vue'),
      children: [
        {
          path: '/admin/enterprises',
          name: 'admin-enterprises',
          component: () => import('./views/Admin/EnterpriseManagement.vue')
        },
        {
          path: '/admin/enterprises/:id',
          name: 'admin-enterprise-detail',
          component: () => import('./views/Admin/EnterpriseDetail.vue')
        },
        {
          path: '/admin/business-changes',
          name: 'admin-business-changes',
          component: () => import('./views/Admin/BusinessChangeApplication.vue')
        },
        {
          path: '/admin/transaction-records',
          name: 'admin-transaction-records',
          component: () => import('./views/Admin/TransactionRecordManagement.vue')
        },
        {
          path: '/admin/service-orders',
          name: 'admin-service-orders',
          component: () => import('./views/Admin/ServiceOrderManagement.vue')
        },
        {
          path: '/admin/tax-applications',
          name: 'admin-tax-applications',
          component: () => import('./views/Admin/TaxApplicationManagement.vue')
        },
        {
          path: '/admin/status-flow-config',
          name: 'admin-status-flow-config',
          meta: {
            requireAdmin: true
          },
          component: () => import('./views/Admin/StatusFlowConfigManagement.vue')
        },
        {
          path: '/admin/users',
          name: 'admin-users',
          component: () => import('./views/Admin/UserManagement.vue')
        },
        {
          path: '/admin/services',
          name: 'admin-services',
          component: () => import('./views/Admin/ServiceManagement.vue')
        },
        {
          path: '/admin/company-config',
          name: 'admin-company-config',
          component: () => import('./views/Admin/CompanyConfigManagement.vue')
        },
        {
          path: '/admin/homepage-config',
          name: 'admin-homepage-config',
          component: () => import('./views/Admin/HomepageConfigManagement.vue')
        },
        {
          path: '/admin/theme-config',
          name: 'admin-theme-config',
          component: () => import('./views/Admin/ThemeConfigManagement.vue')
        },
        {
          path: '/admin/menu-config',
          name: 'admin-menu-config',
          component: () => import('./views/Admin/MenuConfigManagement.vue')
        },
        {
          path: '/admin/announcements',
          name: 'admin-announcements',
          component: () => import('./views/Admin/AnnouncementManagement.vue')
        },
        {
          path: '/admin/footer-config',
          name: 'admin-footer-config',
          component: () => import('./views/Admin/FooterConfigManagement.vue')
        },
        {
          path: '/admin/files',
          name: 'admin-files',
          component: () => import('./views/Admin/FileManagement.vue')
        },
        {
          path: '/admin/applications',
          name: 'admin-applications',
          component: () => import('./views/Admin/ApplicationAudit.vue')
        }
      ]
    },
    {
      path: '/enterprise/apply',
      name: 'enterprise-apply',
      component: () => import('./views/EnterpriseApply.vue')
    }
  ]
})

// 路由守卫：判断是否需要登录权限以及管理员权限
kejianrouter.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const userRole = localStorage.getItem('userRole')

  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (token) {
      // 判断是否需要管理员权限
      if (to.matched.some(res => res.meta.requireAdmin)) {
        if (userRole === 'ADMIN' || userRole === 'SUPER_ADMIN') {
          next()
        } else {
          alert('权限不足，需要管理员权限')
          next('/')
        }
      } else {
        // 检查是否有其他角色要求
        const allowedRoles = to.meta.allowedRoles
        if (allowedRoles && allowedRoles.length > 0) {
          if (allowedRoles.includes(userRole)) {
            next()
          } else {
            alert('权限不足')
            next('/')
          }
        } else {
          next()
        }
      }
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default kejianrouter